<template>
  <div class="pos-container">
    <posFnBHeader :isLogin="true" />

    <div class="cash-given-container">
      <PosCashCalculator nextRoute="pos-fnb" />
      <!-- <nav>
        <router-link to="#" class="btn-outline-blue-lg bg-transparent text-blue mr-2">Back</router-link>
        <router-link to="pos-fnb" class="btn-blue-lg ml-2">Next</router-link>
      </nav>-->
    </div>
  </div>
</template>



<script>
import posFnBHeader from "@/components/Partials/posFnBHeader";
import PosCashCalculator from "@/components/Partials/posCashCalculator";
export default {
  components: {
    posFnBHeader,
    PosCashCalculator
  }
};
</script>

<style>
.pos-cash-calculator {
  margin-bottom: 100px;
}
</style>

 


// WEBPACK FOOTER //
// src/components/Pages/PosFnbContainer/posFnbCashInput.vue